import { Badge, TableCell } from '@/components/ui';
import { IHasChildren } from '@/lib/interface';
import { cn } from '@/lib/utils';

type TProps = IHasChildren & {
  className?: string;
  title?: string;
};

export const DataTableBodyCellBadge = ({ children, title, className }: TProps) => (
  <TableCell className={cn('py-1 pe-0', className)}>
    <Badge className='bg-purple-600 py-0 mx-auto' title={title}>
      {children}
    </Badge>
  </TableCell>
);

export default DataTableBodyCellBadge;
